import axiosInstance from "./axiosInstance";
import API_URL from "./apiBase";

const AgentService = {
  chat: async (messages) => {
    const response = await axiosInstance.post('/api/agent/chat', { messages });
    return response.data;
  },

  streamChat: (messages, onToken, onClear, onAction, onNavigate, onDone, onError) => {
    const token = localStorage.getItem('JWT_TOKEN');
    fetch(`${API_URL}/api/agent/chat/stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({ messages }),
    }).then(async (response) => {
      if (!response.ok) { onError(new Error(`HTTP ${response.status}`)); return; }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let eventName = null;
      let dataParts = [];
      // Accumulate all unnamed text chunks; dispatch only when 'done' arrives
      // so that multi-line responses (blank lines cause multiple SSE events) are
      // assembled into one complete string before the typewriter runs.
      let textAccumulator = '';
      let completedViaSSE = false;

      while (true) {
        const { done, value } = await reader.read();
        // Only call onDone from stream close if the SSE 'done' event never arrived
        // (e.g. network drop). If SSE done already fired, onToken/onDone was already
        // called — calling onDone again here races with the typewriter and overwrites content.
        if (done) { if (!completedViaSSE) onDone(); break; }

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() ?? '';

        for (const line of lines) {
          if (line === '') {
            const data = dataParts.join('\n');
            dataParts = [];
            if (eventName === 'done') {
              completedViaSSE = true;
              console.log('[SSE] done. textAccumulator:', JSON.stringify(textAccumulator));
              if (textAccumulator) onToken(textAccumulator);
              else onDone();
            }
            else if (eventName === 'clear') { onClear(); }
            else if (eventName === 'action') { try { onAction(JSON.parse(data)); } catch (e) {} }
            else if (eventName === 'navigate') { try { onNavigate(JSON.parse(data)); } catch(e) {} }
            else if (eventName === 'error') { onError(new Error(data)); }
            else if (data) {
              textAccumulator += (textAccumulator ? '\n' : '') + data;
            }
            eventName = null;
          } else if (line.startsWith('event:')) {
            eventName = line.slice(6).trim();
          } else if (line.startsWith('data:')) {
            dataParts.push(line.startsWith('data: ') ? line.slice(6) : line.slice(5));
          }
        }
      }
    }).catch(onError);
  },
  execute: async (actionType, parameters) => {
    const response = await axiosInstance.post('/api/agent/execute', { actionType, parameters });
    return response.data;
  },
  extractInvoice: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axiosInstance.post('/api/agent/extract-invoice', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },
};

export default AgentService;
